import { useState } from "react";
import { MwButton, MwInputText, MwTextArea } from "../../ui";
import { RiDeleteBin5Line } from "react-icons/ri";
import { AiOutlineSave, AiOutlineEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";

const AddressForm = ({ errors, address, setAddress }) => {
  const [editableMode, setEditableMode] = useState({ state: false, index: 0 });
  const [t] = useTranslation("global");
  const [newAddress, setNewAddress] = useState({
    country: "",
    state: "",
    name: "",
    city: "",
    region: "",
    street: "",
    desc: "",
  });

  const [addressEditable, setAddressEditable] = useState({
    country: "",
    state: "",
    name: "",
    city: "",
    region: "",
    street: "",
    desc: "",
  });

  const editItem = (index, item) => {
    setEditableMode({ state: true, index });
    setAddressEditable(item);
  };
  const updateItem = (index) => {
    address[index] = addressEditable;
    setAddress([...address]);
    setEditableMode({ state: false, index });
  };

  const deleteItem = (index) => {
    const filter = address.filter((_, i) => i !== index);
    setAddress(filter);
  };

  const addNewHandler = () => {
    if (!newAddress.city) return;
    setAddress([...address, newAddress]);
    setNewAddress({
      country: "",
      state: "",
      name: "",
      city: "",
      region: "",
      street: "",
      desc: "",
    });
  };

  return (
    <>
      <div id="AddNewAddress">
        <div className="flex-1 py-2">
          <MwInputText
            label={t("customers.name")}
            id="newAddress.name"
            value={newAddress.name}
            invalid={!!errors.name}
            invalidMsg={errors.name}
            onChange={(e) => setNewAddress({ ...newAddress, name: e.target.value })}
          />
        </div>
        <div className="flex gap-4 py-2">
          <div className="flex-1 py-2">
            <MwInputText
              label={t("customers.country")}
              id="newAddress.country"
              value={newAddress.country}
              invalid={!!errors.country}
              invalidMsg={errors.country}
              onChange={(e) =>
                setNewAddress({ ...newAddress, country: e.target.value })
              }
            />
          </div>
          <div className="flex-1 py-2">
            <MwInputText
              label={t("customers.state")}
              id="newAddress.state"
              value={newAddress.state}
              invalid={!!errors.state}
              invalidMsg={errors.state}
              onChange={(e) => setNewAddress({ ...newAddress, state: e.target.value })}
            />
          </div>
          <div className="flex-1 py-2">
            <MwInputText
              label={t("customers.city")}
              id="newAddressCity"
              value={newAddress.city}
              invalid={!!errors.newAddressCity}
              invalidMsg={errors.newAddressCity}
              onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
            />
          </div>
        </div>
        <div className="  flex gap-4 py-2">
          <div className="flex-1 ">
            <MwInputText
              label={t("customers.region")}
              id="newAddressRegion"
              value={newAddress.region}
              invalid={!!errors.newAddressRegion}
              invalidMsg={errors.newAddressRegion}
              onChange={(e) => setNewAddress({ ...newAddress, region: e.target.value })}
            />
          </div>

          <div className="flex-1 ">
            <MwInputText
              label={t("customers.street")}
              id="newAddressStreet"
              value={newAddress.street}
              invalid={!!errors.newAddressStreet}
              invalidMsg={errors.newAddressStreet}
              onChange={(e) => setNewAddress({ ...newAddress, street: e.target.value })}
            />
          </div>
        </div>

        <div className="py-2">
          <MwTextArea
            label={t("customers.description")}
            id="newAddressDesc"
            value={newAddress.desc}
            rows={2}
            onChange={(e) => setNewAddress({ ...newAddress, desc: e.target.value })}
          />
        </div>
        <div id="Actions" className="flex justify-end">
          <MwButton type="saveBtn" actionType="button" onClick={addNewHandler}>
            {t("customers.addAddress")}
          </MwButton>
        </div>
      </div>
      {address && address.length > 0 && (
        <div id="ListAddresses" className="bg-slate-100 rounded-lg p-3 my-3">
          <span>{t("customers.addressList")}</span>
          <hr className="my-1" />
          <div className="my-2">
            {address?.map((addr, index) => (
              <div
                key={index}
                className="rounded bg-slate-50 p-3 my-3 gap-4 flex flex-col justify-center"
              >
                <div className="flex justify-between items-center gap-2">
                  <div className="flex-1  gap-2">
                    <label className="text-slate-400">{t("customers.country")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwInputText
                        value={addressEditable.country}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, country: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.country || t("customers.noData")}</span>
                    )}
                  </div>
                  <div className="flex-1  gap-2">
                    <label className="text-slate-400">{t("customers.state")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwInputText
                        value={addressEditable.state}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, state: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.state || t("customers.noData")}</span>
                    )}
                  </div>
                  <div className="flex-1  gap-2">
                    <label className="text-slate-400">{t("customers.city")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwInputText
                        value={addressEditable.city}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, city: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.city || t("customers.noData")}</span>
                    )}
                  </div>
                  <div className="flex-1  gap-2">
                    <label className="text-slate-400">{t("customers.region")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwInputText
                        value={addressEditable.region}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, region: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.region || t("customers.noData")}</span>
                    )}
                  </div>
                  <div className="flex-1 gap-2">
                    <label className="text-slate-400">{t("customers.street")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwInputText
                        value={addressEditable.street}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, street: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.street || t("customers.noData")}</span>
                    )}
                  </div>
                </div>
                <div>
                  <div className="flex-1  gap-2 py-2">
                    <label className="text-slate-400">{t("customers.name")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwTextArea
                        value={addressEditable.name}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, name: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.name || t("customers.noData")}</span>
                    )}
                  </div>
                  <div className="flex-1  gap-2">
                    <label className="text-slate-400">{t("customers.description")}:</label>
                    {editableMode.state && editableMode.index === index ? (
                      <MwTextArea
                        value={addressEditable.desc}
                        onChange={(e) =>
                          setAddressEditable({ ...addressEditable, desc: e.target.value })
                        }
                      />
                    ) : (
                      <span>{addr.desc || t("customers.noData")}</span>
                    )}
                  </div>
                  <div id="actions" className=" flex gap-2 items-center pt-3 justify-end">
                    {editableMode.state && editableMode.index === index ? (
                      <MwButton actionType="button" type="secondary" size="sm" onClick={() => updateItem(index)}>
                        <AiOutlineSave size={18} />
                      </MwButton>
                    ) : (
                      <MwButton actionType="button" type="secondary" size="sm" onClick={() => editItem(index, addr)}>
                        <AiOutlineEdit size={18} />
                      </MwButton>
                    )}
                    <MwButton actionType="button" type="secondary" size="sm" onClick={() => deleteItem(index)}>
                      <RiDeleteBin5Line size={18} />
                    </MwButton>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default AddressForm;

